import React from 'react';
import POS from '.';

export default function TakeawayBuilderPage() {
  return <POS mode="TAKEAWAY" />;
}
